<template>
  <div>
    <xl-dialog modalClass="enclosure-overlay" v-model="show" :title="$t('modelData.hotKeyDescTitle')" custom-class="help-dialog">
		<div class="first">
			<div class="first-item">
				<div class="svg-title">{{$t('modelData.rotateModel')}}</div>
				<div class="first-item-svg">
					<svg class="icon svg-icon" aria-hidden="true">
						<use xlink:href="#icon-zuojian"></use>
					</svg>
					<span>or</span>
					<svg class="icon svg-icon" aria-hidden="true">
						<use xlink:href="#icon-youjian"></use>
					</svg>
				</div>
				<div class="svg-desc">{{$t('modelData.rotateModelDesc')}}</div>
			</div>
			<div class="first-item">
				<div class="svg-title">{{$t('modelData.zoomModel')}}</div>
				<div class="first-item-svg">
					<svg class="icon svg-icon" aria-hidden="true">
						<use xlink:href="#icon-zhongjiangundong"></use>
					</svg>
				</div>
				<div class="svg-desc">{{$t('modelData.zoomModelDesc')}}</div>
			</div>
			<div class="first-item">
				<div class="svg-title">{{$t('modelData.translateModel')}}</div>
				<div class="first-item-svg">
					<span class="hot-key shift">Shift</span>
					<span>+</span>
					<svg class="icon svg-icon" aria-hidden="true">
						<use xlink:href="#icon-zuojian"></use>
					</svg>
				</div>
				<div class="svg-desc">{{$t('modelData.translateModelDesc')}}</div>
			</div>
		</div>
		<!-- <div class="second">
			<div class="second-title">{{$t('modelData.label')}}</div>
			<div class="second-item">
				<div class="left">{{$t('modelData.cancelLabel')}}</div>
				<div class="right">
					<span class="hot-key">esc</span>
				</div>
			</div>
			<div class="second-item">
				<div class="left">{{$t('modelData.changeLabel')}}</div>
				<div class="right">
					<span class='hot-key'>↑</span>
					<span>or</span>
					<span class='hot-key'>↓</span>
				</div>
			</div>
		</div> -->
	</xl-dialog>
  </div>
</template>

<script setup>
import { computed, defineEmits } from 'vue';

import { XlDialog } from '@shining3d/ui-components';
import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang( '@shining3d/app' );

const props = defineProps({
	visible: {
    	type: Boolean,
   		default: false
  	}
});

const emits = defineEmits(['update:visible']);

const show = computed({
	get: () => props.visible,
	set: ( val ) => {
		emits( 'update:visible', val );
	}
});

</script>

<style scoped lang="scss">
:deep(.help-dialog) {
	min-width: 500px;
	.first {
		margin-top: 16px;
		display: flex;
		.first-item:not(:first-of-type) {
			margin-left: 16px;
		}
		.first-item {
			width: calc((100% - 32px) / 3);
			background-color: rgba(92, 104, 115, .08);
			border-radius: 6px;
			text-align: center;
			padding: 16px 16px 10px;
			flex-wrap: wrap;
			color: $color-n9;
			font-size: 14px;
			.first-item-svg {
				width: 100%;
				margin-top: 12px;
				svg {
					width: 30px;
					height: 30px;
					margin: 0 8px;
				}
				.hot-key.shift {
					width: 50px;
					height: 28px;
					line-height: 24px;
					margin: 0 8px;
				}
			}
			.svg-desc {
				width: 100%;
				text-align: center;
				margin-top: 8px;
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				white-space: pre-wrap;
				-webkit-line-clamp: 2;
				color: $color-n8;
				font-size: 14px;
				line-height: 20px;
			}
			.svg-title {
				width: 100%;
				text-align: center;
				font-size: 14px;
				line-height: 20px;
				@include font-family85();
			}
		}
	}
	.second {
		margin-top: 15px;
		margin-bottom: 16px;
		.second-title {
			font-size: 16px;
			font-weight: 600;
			padding: 9px 0;
			color: $color-n10;
		}
		.second-item {
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: 14px;
			color: $color-n10;
			padding: 8px 16px;
			border-radius: 6px;
			&:nth-child(2n) {
				background-color: rgba(92, 104, 115, .08);
			}
			.hot-key {
				width: 32px;
				height: 28px;
				line-height: 24px;
			}
			.right>span {
				margin-left: 8px;
				color: $color-n9;
			}
		}
	}
}
</style>
